<template>
    <div class="manage-dict-container">
        <div class="card-container">
            <el-tabs v-model="activeTab" @tab-click="handleTabClick">
                <!-- 学院专业 -->
                <el-tab-pane label="学院专业" name="XYZY">
                    <div class="dict-content">
                        <div class="toolbar">
                            <el-button type="primary" icon="el-icon-plus" @click="handleAddAcademy">添加学院</el-button>
                            <el-button type="success" icon="el-icon-upload" @click="showImportDialog">批量导入</el-button>
                            <el-button type="success" icon="el-icon-refresh" @click="loadTreeData">刷新</el-button>
                        </div>
                        <yt-tree-view
                            v-if="treeData.length > 0"
                            :list-nodes="treeData"
                            :show-level-badge="true">
                            <template slot="header">
                                <th style="text-align: left !important; background-color: #f5f7fa; color: #606266; font-weight: 600; border-bottom: 1px solid #dfe6ec;">学院/专业名称</th>
                                <th style="text-align: center !important; background-color: #f5f7fa; color: #606266; font-weight: 600; border-bottom: 1px solid #dfe6ec;">匹配专业名称</th>
                                <th style="text-align: center !important; background-color: #f5f7fa; color: #606266; font-weight: 600; border-bottom: 1px solid #dfe6ec;">层次</th>
                                <th style="text-align: center !important; background-color: #f5f7fa; color: #606266; font-weight: 600; border-bottom: 1px solid #dfe6ec;">学制</th>
                                <th style="text-align: center !important; background-color: #f5f7fa; color: #606266; font-weight: 600; border-bottom: 1px solid #dfe6ec;">操作</th>
                            </template>
                            <template slot="content" slot-scope="{ node, level }">
                                <td style="text-align: left !important;">
                                    <span v-if="level === 0" style="font-weight: bold; color: #303133;">{{ node.Name }}</span>
                                    <span v-else style="color: #606266;">{{ node.Name }}</span>
                                </td>
                                <td>
                                    <span v-if="level > 0">{{ node.DaiMa }}</span>
                                    <span v-else>-</span>
                                </td>
                                <td>{{ node.ZiDuan2 || '-' }}</td>
                                <td>{{ node.ZiDuan3 || '-' }}</td>
                                <td>
                                    <div class="action-buttons">
                                        <el-button v-if="level === 0" type="text" size="mini" icon="el-icon-plus" @click.stop="() => handleAddMajor(node)">添加专业</el-button>
                                        <el-button type="text" size="mini" icon="el-icon-edit" @click.stop="() => handleEdit(node)">编辑</el-button>
                                        <el-button type="text" size="mini" icon="el-icon-delete" @click.stop="() => handleDelete(node)" style="color: #F56C6C;">删除</el-button>
                                    </div>
                                </td>
                            </template>
                        </yt-tree-view>
                        <div v-else class="empty-text">暂无数据</div>
                    </div>
                </el-tab-pane>

                <!-- 招生类型 -->
                <el-tab-pane label="招生类型" name="ZSLX">
                    <div class="dict-content">
                        <div class="toolbar">
                            <el-button type="primary" icon="el-icon-plus" @click="onDictListAdd">添加</el-button>
                            <el-button type="success" icon="el-icon-refresh" @click="loadDictData('ZSLX')">刷新</el-button>
                        </div>
                        <div class="data-table">
                            <el-table :data="dictData.ZSLX" border style="width: 100%" class="common-table" v-loading="loading.ZSLX" :header-cell-style="tableHeaderStyle">
                                <el-table-column prop="Name" label="招生类型名称" min-width="200"></el-table-column>
                                <el-table-column prop="ZiDuan2" label="层次" min-width="120" align="center">
                                    <template slot-scope="scope">
                                        <el-tag size="small" v-if="scope.row.ZiDuan2">{{ scope.row.ZiDuan2 }}</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" min-width="180" align="center" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="mini" icon="el-icon-edit" @click="onDictListEdit(scope.row)">编辑</el-button>
                                        <el-button type="text" size="mini" icon="el-icon-delete" @click="handleDelete(scope.row)" style="color: #F56C6C;">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-tab-pane>

                <!-- 科类 -->
                <el-tab-pane label="科类" name="KL">
                    <div class="dict-content">
                        <div class="toolbar">
                            <el-button type="primary" icon="el-icon-plus" @click="onDictListAdd">添加</el-button>
                            <el-button type="success" icon="el-icon-refresh" @click="loadDictData('KL')">刷新</el-button>
                        </div>
                        <div class="data-table">
                            <el-table :data="dictData.KL" border style="width: 100%" class="common-table" v-loading="loading.KL" :header-cell-style="tableHeaderStyle">
                                <el-table-column prop="Name" label="科类名称" min-width="200"></el-table-column>
                                <el-table-column label="操作" min-width="180" align="center" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="mini" icon="el-icon-edit" @click="onDictListEdit(scope.row)">编辑</el-button>
                                        <el-button type="text" size="mini" icon="el-icon-delete" @click="handleDelete(scope.row)" style="color: #F56C6C;">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-tab-pane>

                <!-- 批次 -->
                <el-tab-pane label="批次" name="PC">
                    <div class="dict-content">
                        <div class="toolbar">
                            <el-button type="primary" icon="el-icon-plus" @click="onDictListAdd">添加</el-button>
                            <el-button type="success" icon="el-icon-refresh" @click="loadDictData('PC')">刷新</el-button>
                        </div>
                        <div class="data-table">
                            <el-table :data="dictData.PC" border style="width: 100%" class="common-table" v-loading="loading.PC" :header-cell-style="tableHeaderStyle">
                                <el-table-column prop="Name" label="批次名称" min-width="200"></el-table-column>
                                <el-table-column label="操作" min-width="180" align="center" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="mini" icon="el-icon-edit" @click="onDictListEdit(scope.row)">编辑</el-button>
                                        <el-button type="text" size="mini" icon="el-icon-delete" @click="handleDelete(scope.row)" style="color: #F56C6C;">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-tab-pane>

                <!-- 考生类别 -->
                <el-tab-pane label="考生类别" name="KSLB">
                    <div class="dict-content">
                        <div class="toolbar">
                            <el-button type="primary" icon="el-icon-plus" @click="onDictListAdd">添加</el-button>
                            <el-button type="success" icon="el-icon-refresh" @click="loadDictData('KSLB')">刷新</el-button>
                        </div>
                        <div class="data-table">
                            <el-table :data="dictData.KSLB" border style="width: 100%" class="common-table" v-loading="loading.KSLB" :header-cell-style="tableHeaderStyle">
                                <el-table-column prop="Name" label="考生类别名称" min-width="200"></el-table-column>
                                <el-table-column label="操作" min-width="180" align="center" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="mini" icon="el-icon-edit" @click="onDictListEdit(scope.row)">编辑</el-button>
                                        <el-button type="text" size="mini" icon="el-icon-delete" @click="handleDelete(scope.row)" style="color: #F56C6C;">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-tab-pane>

                <!-- 毕业类别 -->
                <el-tab-pane label="毕业类别" name="BYLB">
                    <div class="dict-content">
                        <div class="toolbar">
                            <el-button type="primary" icon="el-icon-plus" @click="onDictListAdd">添加</el-button>
                            <el-button type="success" icon="el-icon-refresh" @click="loadDictData('BYLB')">刷新</el-button>
                        </div>
                        <div class="data-table">
                            <el-table :data="dictData.BYLB" border style="width: 100%" class="common-table" v-loading="loading.BYLB" :header-cell-style="tableHeaderStyle">
                                <el-table-column prop="Name" label="毕业类别名称" min-width="200"></el-table-column>
                                <el-table-column label="操作" min-width="180" align="center" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="mini" icon="el-icon-edit" @click="onDictListEdit(scope.row)">编辑</el-button>
                                        <el-button type="text" size="mini" icon="el-icon-delete" @click="handleDelete(scope.row)" style="color: #F56C6C;">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-tab-pane>

                <!-- 高中信息 -->
                <el-tab-pane label="高中信息" name="GZXX">
                    <div class="dict-content">
                        <div class="toolbar">
                            <el-button type="primary" icon="el-icon-plus" @click="onDictListAdd">添加</el-button>
                            <el-button type="success" icon="el-icon-refresh" @click="loadDictData('GZXX')">刷新</el-button>
                        </div>
                        <div class="data-table">
                            <el-table :data="dictData.GZXX" border style="width: 100%" class="common-table" v-loading="loading.GZXX" :header-cell-style="tableHeaderStyle">
                                <el-table-column prop="Name" label="高中名称" min-width="200"></el-table-column>
                                <el-table-column label="操作" min-width="180" align="center" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="mini" icon="el-icon-edit" @click="onDictListEdit(scope.row)">编辑</el-button>
                                        <el-button type="text" size="mini" icon="el-icon-delete" @click="handleDelete(scope.row)" style="color: #F56C6C;">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>

        <!-- 添加/编辑对话框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
            <el-form :model="form" label-width="120px">
                <el-form-item :label="nameLabel">
                    <el-input v-model="form.name" :placeholder="namePlaceholder"></el-input>
                </el-form-item>
                
                <!-- 代码 (学院: 代码; 专业: 匹配名称; 其他: 默认不填) -->
                <el-form-item :label="codeLabel" v-if="showCode">
                    <el-input v-model="form.code" :placeholder="codePlaceholder"></el-input>
                </el-form-item>

                <!-- 层次 (专业、招生类型) -->
                <el-form-item label="层次" v-if="showLevel">
                    <el-select v-model="form.level" placeholder="请选择层次" style="width: 100%">
                        <el-option label="本科" value="本科"></el-option>
                        <el-option label="高职（专科）" value="高职（专科）"></el-option>
                    </el-select>
                </el-form-item>

                <!-- 学制 (专业) -->
                <el-form-item label="学制" v-if="showDuration">
                    <el-input v-model="form.duration" placeholder="例如：4年"></el-input>
                </el-form-item>

                <!-- 备注 (学院) -->
                <el-form-item label="备注" v-if="showRemark">
                    <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSave" :loading="saving">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 批量导入对话框 -->
        <el-dialog title="批量导入学院专业" :visible.sync="importDialogVisible" width="700px">
            <div class="info-box info">
                <i class="el-icon-info"></i>
                <div>
                    <p><strong>说明：</strong></p>
                    <ul>
                        <li>请下载Excel模板，按照模板格式填写学院专业信息</li>
                        <li>模板包含字段：学院名称、学院代码（可为空）、层次、校内专业名称、匹配专业名称、学制（可为空）</li>
                        <li>系统将按学院分组添加，已存在的学院或专业将被跳过</li>
                    </ul>
                </div>
            </div>

            <div class="actions">
                <el-button type="success" icon="el-icon-download" @click="downloadTemplate">下载Excel模板</el-button>
            </div>

            <el-divider></el-divider>

            <el-form :model="importForm" label-width="120px">
                <el-form-item label="Excel文件">
                    <el-upload
                        class="upload-demo"
                        action="#"
                        :auto-upload="false"
                        :on-change="handleFileChange"
                        :on-remove="handleFileRemove"
                        :file-list="fileList"
                        accept=".xls"
                        :limit="1">
                        <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传xls文件</div>
                    </el-upload>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="handleImportSubmit" :disabled="!uploadFile || importing" :loading="importing">
                        开始导入
                    </el-button>
                </el-form-item>
            </el-form>

            <div v-if="importResult" class="result-section">
                <el-divider>导入结果</el-divider>
                <div v-html="importResult" class="result-content"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { TYBM_Env } from '../../env.js';
import { TYBM_Tools } from '../../tools.js';
import YtTreeView from '../Shared/YtTreeView.vue';

export default {
    name: 'ManageDict',
    components: {
        YtTreeView
    },
    data() {
        return {
            activeTab: 'XYZY',
            treeData: [],
            defaultProps: {
                children: 'ListSons',
                label: 'Name'
            },
            dictData: {
                ZSLX: [],
                KL: [],
                PC: [],
                KSLB: [],
                BYLB: [],
                GZXX: []
            },
            loading: {
                ZSLX: false,
                KL: false,
                PC: false,
                KSLB: false,
                BYLB: false,
                GZXX: false
            },
            tableHeaderStyle: {
            backgroundColor: '#f5f7fa',
            color: '#606266',
            fontWeight: '600',
            borderBottom: '1px solid #dfe6ec'
        },
        dialogVisible: false,
            dialogTitle: '添加',
            saving: false,
            form: {
                SN: 0,
                name: '',
                code: '',
                remark: '',
                level: '',
                duration: '',
                parentSN: 0 // For Major
            },
            // Current editing context
            editingType: '', // 'XYZY', 'ZSLX', etc.
            
            // 批量导入
            importDialogVisible: false,
            importForm: {},
            fileList: [],
            uploadFile: null,
            importing: false,
            importResult: ''
        };
    },
    computed: {
        isAcademy() {
            return this.activeTab === 'XYZY' && this.form.parentSN === 0;
        },
        isMajor() {
            return this.activeTab === 'XYZY' && this.form.parentSN !== 0;
        },
        nameLabel() {
            if (this.isAcademy) return '学院名称';
            if (this.isMajor) return '校内专业名称';
            return '名称';
        },
        namePlaceholder() {
            if (this.isAcademy) return '请输入学院名称';
            if (this.isMajor) return '请输入校内专业名称';
            return '请输入名称';
        },
        showCode() {
            // Academy needs Code, Major needs MatchName (stored in DaiMa)
            return this.activeTab === 'XYZY';
        },
        codeLabel() {
            if (this.isAcademy) return '学院代码';
            if (this.isMajor) return '匹配专业名称';
            return '代码';
        },
        codePlaceholder() {
            if (this.isAcademy) return '请输入学院代码';
            if (this.isMajor) return '请输入用于匹配的专业名称';
            return '请输入代码';
        },
        showLevel() {
            return this.isMajor || this.activeTab === 'ZSLX';
        },
        showDuration() {
            return this.isMajor;
        },
        showRemark() {
            return this.isAcademy; // Only Academy explicitly uses Remark in prompt
        }
    },
    methods: {
        handleTabClick(tab) {
            if (tab.name === 'XYZY') {
                this.loadTreeData();
            } else {
                this.loadDictData(tab.name);
            }
        },
        loadTreeData() {
            const api_name = '/Dict/GetDictList';
            const url = TYBM_Env.GetApiUrl(api_name) + '?type=XYZY';
            
            TYBM_Tools.AxiosGetEx(this, api_name, url, { loading: false })
                .then(response => {
                    const list = response.data;
                    // Build Tree
                    const academies = list.filter(item => item.ZiDuan1 == 0 || item.ZiDuan1 == "0");
                    const majors = list.filter(item => item.ZiDuan1 != 0 && item.ZiDuan1 != "0");
                    
                    academies.forEach(academy => {
                        academy.ListSons = majors.filter(major => major.ZiDuan1 == academy.SN);
                        // YtTreeView needs IsExpand property to control expansion
                        academy.IsExpand = 0; // 0 means expanded by default? Based on YtTreeView: :class="item.node.IsExpand === 0 ? 'chevron-down'
                    });
                    
                    this.treeData = academies;
                });
        },
        loadDictData(type) {
            const api_name = '/Dict/GetDictList';
            const url = TYBM_Env.GetApiUrl(api_name) + '?type=' + type;
            
            this.loading[type] = true;
            TYBM_Tools.AxiosGetEx(this, api_name, url, { loading: false })
                .then(response => {
                    this.dictData[type] = response.data;
                })
                .finally(() => {
                    this.loading[type] = false;
                });
        },
        // --- XYZY Handlers ---
        handleNodeClick(data) {
            console.log('Node click:', data);
        },
        handleAddAcademy() {
            this.editingType = 'XYZY';
            this.dialogTitle = '添加学院';
            this.form = {
                SN: 0,
                name: '',
                code: '',
                order: 0,
                remark: '',
                level: '',
                duration: '',
                parentSN: 0
            };
            this.dialogVisible = true;
        },
        handleAddMajor(academy) {
            this.editingType = 'XYZY';
            this.dialogTitle = '添加专业';
            this.form = {
                SN: 0,
                name: '',
                code: '', // Match Name
                order: 0,
                remark: '',
                level: '',
                duration: '',
                parentSN: academy.SN
            };
            this.dialogVisible = true;
        },
        // --- Generic Handlers ---
        handleEdit(data) {
            this.editingType = this.activeTab;
            // Ensure parentSN is parsed as integer for correct comparison in computed properties
            const parentSN = parseInt(data.ZiDuan1) || 0;
            this.dialogTitle = parentSN === 0 ? '编辑学院' : '编辑专业';
            
            this.form = {
                SN: data.SN,
                name: data.Name,
                code: data.DaiMa,
                remark: data.BeiZhu,
                level: data.ZiDuan2,
                duration: data.ZiDuan3,
                parentSN: parentSN
            };
            this.dialogVisible = true;
        },
        handleDelete(data) {
            this.$confirm('确定要删除该项吗？', '提示', {
                type: 'warning'
            }).then(() => {
                const api_name = '/Dict/DeleteDictItem';
                const url = TYBM_Env.GetApiUrl(api_name) + '?SN=' + data.SN;
                
                TYBM_Tools.AxiosGetEx(this, api_name, url, { loading_msg: '正在删除' })
                    .then(() => {
                        this.$message.success('删除成功');
                        if (this.activeTab === 'XYZY') {
                            this.loadTreeData();
                        } else {
                            this.loadDictData(this.activeTab);
                        }
                    });
            });
        },
        onDictListAdd() {
            this.editingType = this.activeTab;
            this.dialogTitle = '添加';
            this.form = {
                SN: 0,
                name: '',
                code: '',
                order: 0,
                remark: '',
                level: '',
                duration: '',
                parentSN: 0
            };
            this.dialogVisible = true;
        },
        onDictListEdit(data) {
            this.editingType = this.activeTab;
            this.handleEdit(data);
        },
        
        handleSave() {
            const api_name = '/Dict/SaveDictItem';
            const url = TYBM_Env.GetApiUrl(api_name) + '?type=' + this.editingType;
            
            const submitModel = {
                SN: this.form.SN,
                Name: this.form.name,
                DaiMa: this.form.code,
                PaiXu: 1000, // Default sort order since we removed the field
                BeiZhu: this.form.remark,
                ZiDuan1: this.form.parentSN.toString(),
                ZiDuan2: this.form.level,
                ZiDuan3: this.form.duration
            };
            
            // Standard GxzsSubmitApi expects a "Model" parameter containing the JSON string
            const data = {
                Model: JSON.stringify(submitModel)
            };

            this.saving = true;
            TYBM_Tools.AxiosPostEx(this, api_name, url, data, { loading: false })
                .then(() => {
                    this.$message.success('保存成功');
                    this.dialogVisible = false;
                    
                    if (this.activeTab === 'XYZY') {
                        this.loadTreeData();
                    } else {
                        this.loadDictData(this.activeTab);
                    }
                })
                .finally(() => {
                    this.saving = false;
                });
        },
        
        // 批量导入相关方法
        showImportDialog() {
            this.importDialogVisible = true;
            this.fileList = [];
            this.uploadFile = null;
            this.importResult = '';
        },
        downloadTemplate() {
            const timestamp = new Date().getTime();
            window.open(`/GXZS/Template/v1学院专业导入模板.xls?t=${timestamp}`, '_blank');
        },
        handleFileChange(file) {
            this.uploadFile = file.raw;
        },
        handleFileRemove() {
            this.uploadFile = null;
        },
        handleImportSubmit() {
            const that = this;
            const api_name = '/Dict/ImportXyzy';
            const data = { "RarFile": that.uploadFile };
            const url = TYBM_Env.GetApiUrl(api_name);
            
            that.importing = true;
            TYBM_Tools.AxiosUploadFile(that, api_name, url, data, { loading_msg: '正在处理', has_progress: true })
                .then(result => {
                    that.importResult = result.data.Msg;
                    that.$message.success('导入完成');
                    that.loadTreeData();
                })
                .catch(() => {
                    that.$message.error('导入失败');
                })
                .finally(() => {
                    that.importing = false;
                });
        }
    },
    mounted() {
        if (this.activeTab === 'XYZY') {
            this.loadTreeData();
        }
    }
};
</script>

<style scoped>
.dict-content {
    padding: 20px 0;
}

.toolbar {
    margin-bottom: 20px;
}

.data-table {
    background: white;
    border-radius: 8px;
    overflow-x: auto;
}

.data-table >>> .el-table {
    font-size: 13px;
}

.data-table >>> .el-table th,
.data-table >>> .el-table td {
    padding: 8px 0 !important;
}

.data-table >>> .el-table th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 600;
}

.data-table >>> .el-table__row:hover {
    background-color: #f5f9ff;
}

.data-table >>> .el-table .cell {
    padding: 0 8px;
}

.empty-text {
    text-align: center;
    color: #909399;
    padding: 20px;
}

.action-buttons {
    display: flex;
    justify-content: center;
    gap: 8px;
}

/* 导入对话框样式 */
.info-box {
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 24px;
    border-left: 4px solid #1890ff;
    background-color: #e6f7ff;
    color: #0050b3;
    display: flex;
    gap: 12px;
}

.info-box i {
    font-size: 20px;
    margin-top: 2px;
}

.info-box ul {
    margin: 8px 0 0 20px;
}

.actions {
    margin-bottom: 20px;
}

.result-section {
    margin-top: 20px;
}

.result-content {
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
    max-height: 300px;
    overflow-y: auto;
}

.upload-demo >>> .el-upload {
    display: inline-block;
}

.upload-demo >>> .el-upload input[type="file"] {
    display: none !important;
}
</style>
